module.exports = __webpack_public_path__ + "img/olsson-parts-blue-logo.svg";